"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHandlebarsWithHelpers = exports.DEFAULT_HANDLEBARS_HELPERS = exports.getPartialNameFromFileName = exports.Handlebars = void 0;
const handlebars_1 = __importDefault(require("handlebars"));
exports.Handlebars = handlebars_1.default;
const change_case_1 = require("./change-case");
/**
 * Given a file name, return the desirable name for a handlebars extension
 * The extension is in camel case without the file suffix, and all slashes
 * and spaces get removed
 *
 * @param fileName - Filename
 * @param extension - File extension
 * @returns Partial name
 */
function getPartialNameFromFileName(fileName, extension = 'hbs') {
    return change_case_1.cases.camelCase(fileName
        .slice(0, fileName.length - `.${extension}`.length)
        .split('/')
        .pop());
}
exports.getPartialNameFromFileName = getPartialNameFromFileName;
/**
 * Default helper functions to register
 */
exports.DEFAULT_HANDLEBARS_HELPERS = {
    ...change_case_1.cases,
    /**
     * Pad with back slashes
     *
     * @param word - The word to pad
     * @returns Slashes the length of the word
     */
    pad: (word) => '/'.repeat(word.length),
    /**
     * Render if equality is met
     *
     * @param this - This context
     * @param arg1 - First arg
     * @param arg2 - Second arg
     * @param options - Handlebars options
     * @returns The template if args are equal
     */
    ifEqual: function ifNotEqual(arg1, arg2, options) {
        return arg1 === arg2 ? options.fn(this) : options.inverse(this);
    },
    /**
     * Render if equality is not met
     *
     * @param this - This context
     * @param arg1 - First arg
     * @param arg2 - Second arg
     * @param options - Handlebars options
     * @returns The template if args are not equal
     */
    ifNotEqual: function ifNotEqual(arg1, arg2, options) {
        return arg1 !== arg2 ? options.fn(this) : options.inverse(this);
    },
    /**
     * Uri encode a string
     *
     * @param word - The word to encode
     * @returns The URI encoded word
     */
    safeString: (word) => encodeURI(word),
    /**
     * Get the length of a list
     *
     * @param list - The list in question
     * @returns The length of the list
     */
    listLen: (list) => list === null || list === void 0 ? void 0 : list.length,
    /**
     * Convert a JSON object to string
     *
     * @param obj - The object to convert
     * @returns The object stringified
     */
    toJSON: (obj) => JSON.stringify(obj, (k, v) => {
        // Necessary, else functions don't get written.
        if (typeof v === 'function') {
            return v.toString();
        }
        return v;
    }),
    /**
     * Compares two string to see if they're sorted
     *
     * @param arg1 - Some string
     * @param arg2 - Some other string to compare against
     * @param options - Handlebar options
     * @returns boolean
     */
    ifSorted: function ifSorted(arg1, arg2, options) {
        return arg1 <= arg2 ? options.fn(this) : options.inverse(this);
    },
};
/**
 * Create an instance of handlebars, loading partial templates and adding utilities
 *
 * @param input - Input to define the handlebars instance
 * @returns The instantiated instance of handlebars
 */
function createHandlebarsWithHelpers({ templates = [], helpers = {}, } = {}) {
    if (templates.length > 0) {
        // Register partials
        templates.forEach(({ name, content }) => handlebars_1.default.registerPartial(name, content));
    }
    // Register helpers
    Object.entries({
        ...exports.DEFAULT_HANDLEBARS_HELPERS,
        ...helpers,
    }).forEach(([key, func]) => handlebars_1.default.registerHelper(key, func));
    return handlebars_1.default;
}
exports.createHandlebarsWithHelpers = createHandlebarsWithHelpers;
//# sourceMappingURL=createHandlebars.js.map